/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Delete_Account_TitleInputs */

const en_settings_delete_account_title = /** @type {(inputs: Settings_Delete_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete Account`)
};

const de_settings_delete_account_title = /** @type {(inputs: Settings_Delete_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konto loeschen`)
};

const fr_settings_delete_account_title = /** @type {(inputs: Settings_Delete_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer le compte`)
};

const es_settings_delete_account_title = /** @type {(inputs: Settings_Delete_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar cuenta`)
};

const it_settings_delete_account_title = /** @type {(inputs: Settings_Delete_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elimina account`)
};

const nl_settings_delete_account_title = /** @type {(inputs: Settings_Delete_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account verwijderen`)
};

const pl_settings_delete_account_title = /** @type {(inputs: Settings_Delete_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usun konto`)
};

const fi_settings_delete_account_title = /** @type {(inputs: Settings_Delete_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poista tili`)
};

const da_settings_delete_account_title = /** @type {(inputs: Settings_Delete_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slet konto`)
};

const sv_settings_delete_account_title = /** @type {(inputs: Settings_Delete_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ta bort konto`)
};

/**
* | output |
* | --- |
* | "Delete Account" |
*
* @param {Settings_Delete_Account_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_delete_account_title = /** @type {((inputs?: Settings_Delete_Account_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Delete_Account_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_delete_account_title(inputs)
	if (locale === "fr") return fr_settings_delete_account_title(inputs)
	if (locale === "es") return es_settings_delete_account_title(inputs)
	if (locale === "it") return it_settings_delete_account_title(inputs)
	if (locale === "nl") return nl_settings_delete_account_title(inputs)
	if (locale === "pl") return pl_settings_delete_account_title(inputs)
	if (locale === "fi") return fi_settings_delete_account_title(inputs)
	if (locale === "da") return da_settings_delete_account_title(inputs)
	if (locale === "sv") return sv_settings_delete_account_title(inputs)
	return en_settings_delete_account_title(inputs)
});